export const DEFAULT_EVENT_ID = process.env.REACT_APP_EVENT_ID || 'jawsdays-2026';
